import React, {  useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIdleTimer } from 'react-idle-timer'
import { format } from 'react-string-format'
import { Classes, Dialog } from '@blueprintjs/core'
// import { CoreContext } from './coreContext'
import useLogOut from 'lib/useLogOut'
import { userSelector, useUserStore } from 'store/userInfo.store'
let remainTime
let timer
const IddleContext = ({ children }) => {
  const { t } = useTranslation()
  // const { core } = useContext(CoreContext)
  const { logOut } = useLogOut()
  const [showIddle, setShowIddle] = useState(false)
  const [remain, setRemain] = useState()
  const currentUser = useUserStore(userSelector)
  const isLogin = () => {
    return currentUser?.id ? true : false
  }
  const handleOnIdle = (event) => {
    if (isLogin()) {
      remainTime = process.env.REACT_APP_IDLE_COUNTDOWN
      setRemain(remainTime)
      setShowIddle(true)
      timer = setInterval(() => {
        remainTime -= 1
        setRemain(remainTime)
        if (remainTime < 1) {
          clearInterval(timer)
          setShowIddle(false)
          logOut()
        }
      }, 1000)
    }
    // console.log('user is idle', core)
    // console.log('last active', getLastActiveTime())
  }

  const handleOnActive = (event) => {
    if (isLogin()) {
      setShowIddle(false)
      clearInterval(timer)
    }
    // console.log('user is active')
    // console.log('time remaining', getRemainingTime())
  }

  // const handleOnAction = (e) => {
  //   console.log('user did something', isLogin())
  // }
  // const { getRemainingTime, getLastActiveTime } = useIdleTimer({
  //   timeout: 1000 * 60 * 0.2,
  //   onIdle: handleOnIdle,
  //   onActive: handleOnActive,
  //   // onAction: handleOnAction,
  //   debounce: 500,
  // })

  useIdleTimer({
    timeout: 1000 * 60 * process.env.REACT_APP_IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    // onAction: handleOnAction,
    debounce: 500,
  })
  return (
    <>
      <Dialog icon='info-sign' isCloseButtonShown={false} title={t('session_timeout')} isOpen={showIddle}>
        <div className={Classes.DIALOG_BODY}>
          <div className='alert alert-danger mt-2'>
            {format(t('session_timeout_message'), remain)}
          </div>
        </div>
      </Dialog>
      {children}
    </>
  )
}
export default IddleContext
